import Divider from "@mui/material/Divider"
import Link from "@mui/material/Link"
import { styled } from "@mui/material/styles"
import { Link as RouterLink } from "react-router-dom"

import { SIDEBAR_WIDTH_COLLAPSED } from "../../pages/customer/components/SidebarLinks"
import { useIsMobile } from "../utils"
import Column from "./Column"
import { GlassMixinVariant2 } from "./GlassMixin"
import Row from "./Row"

export default function Footer({ Wrapper = UserFooterRow }) {
  const isMobile = useIsMobile()
  return (
    <Wrapper>
      <Row sx={{ gap: 2, alignItems: "center" }}>
        <WhiteLink to="/">Homepage</WhiteLink>
        <FooterDivider />
        <WhiteLink to="/privacy-policy">
          {isMobile ? "Privacy" : "Privacy Policy"}
        </WhiteLink>
        <FooterDivider />
        <WhiteLink to="/terms">
          {isMobile ? "Terms" : "Terms and Conditions"}
        </WhiteLink>
        <FooterDivider />
        <WhiteLink to="/ai-usage">{isMobile ? "AI" : "AI Usage"}</WhiteLink>
      </Row>
    </Wrapper>
  )
}

export const FOOTER_HEIGHT = "48px"

export const UserFooterRow = styled(Row)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: FOOTER_HEIGHT,
  padding: theme.spacing(2),
  background:
    "linear-gradient(-90deg, rgba(137, 47, 206, 1) 3%, rgba(137, 47, 206, 0.8) 100%)",
  boxShadow: GlassMixinVariant2.boxShadow,
  backdropFilter: "blur(7px)",
  WebkitBackdropFilter: "blur(7px)",
  border: "1px solid rgba(137, 47, 206, 0.5)",
}))

export const CustomerFooterRow = styled(UserFooterRow)(({ theme }) => ({
  left: SIDEBAR_WIDTH_COLLAPSED,
  width: `calc(100% - ${SIDEBAR_WIDTH_COLLAPSED})`,
  [theme.breakpoints.only("xs")]: {
    left: 0,
    width: "100%",
  },
}))

export const BLOCK_AFTER_STYLES = {
  "&:after": {
    content: `""`,
    display: "block",
    height: FOOTER_HEIGHT,
  },
}

export const FooterReadyColumn = styled(Column)(() => ({
  position: "relative",
  minHeight: "100vh",
  ...BLOCK_AFTER_STYLES,
}))

const WhiteLink = styled((props) => <Link component={RouterLink} {...props} />)(
  () => ({
    color: "white",
  })
)

const FooterDivider = styled((props) => (
  <Divider orientation="vertical" {...props} />
))(({ theme }) => ({
  borderColor: "white",
  opacity: 0.3,
  borderWidth: "1px",
  height: "24px",
}))
